import React from 'react';
import { Hero } from '../components/Hero';
import { PainPoints } from '../components/PainPoints';
import { SystemIntro } from '../components/SystemIntro';
import { Tomos } from '../components/Tomos';
import { Bonuses } from '../components/Bonuses';
import { Offer } from '../components/Offer';
import { AccessDetails } from '../components/AccessDetails';
import { Guarantee } from '../components/Guarantee';
import { Faq } from '../components/Faq';
import { FinalCta } from '../components/FinalCta';
import { Footer } from '../components/Footer';
import { StickyBuyBar } from '../components/StickyBuyBar';
export function Landing() {
  return <div className="w-full bg-white pb-24 font-sans text-ink sm:pb-20" data-id="element-242" data-mp="88m1wp67lkr1">
      <Hero data-id="element-243" data-mp="c8cp6iwj1iqt" />
      <main data-id="element-244" data-mp="c84dguc54jh7">
        <PainPoints data-id="element-245" data-mp="c8mdm21xbhue" />
        <SystemIntro data-id="element-246" data-mp="cb8lk2sq7zd5" />
        <Tomos data-id="element-247" data-mp="h90pjv6nbbxp" />
        <Bonuses data-id="element-248" data-mp="h9a6yudmkars" />
        <Offer data-id="element-249" data-mp="h9tq2ef0h57e" />
        <AccessDetails data-id="element-250" data-mp="habrdpgj69m6" />
        <Guarantee data-id="element-251" data-mp="m7legygg696u" />
        <Faq data-id="element-252" data-mp="m728mg42nb96" />
        <FinalCta data-id="element-253" data-mp="m8n202engo5g" />
      </main>
      <Footer data-id="element-254" data-mp="m7v42kxkyec0" />
      <StickyBuyBar data-id="element-255" data-mp="m58z8t22qcxh" />
    </div>;
}